import styled from '@emotion/styled';
import { GridItem, IGridItemProps } from '../../../../../../ui';
import Responsive from '../../../../../../ui/utils/Responsive';

export interface IColumnProps extends IGridItemProps {}

export const Column = styled(GridItem)<IGridItemProps>`
	margin: 0px;
	padding-left: 20px;
	padding-right: 20px;
	padding-top: 10px;
	padding-bottom: 10px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		min-width: 100%;
	}
`;

export const ColumnContent = styled.div`
	font-weight: 700;
	font-size: 15px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-bottom: 10px;
		border-bottom: 2px solid #f7f7f7;
	}
`;
